import axios from "axios";
import {
  getStoredUser,
  getStoredDeviceInfo,
  getReduxCompany,
} from "../helper/sessionHelper";
import { getStoredCompany } from "../helper/sessionHelper";

import {
  refreshAccessToken
} from "../apis/apiServices/User";






const devideInfo = getStoredDeviceInfo();
const user = getStoredUser();
const company = getStoredCompany(); //secureLocalStorage.getItem("company");
const token = sessionStorage.getItem("session_accesstoken")
//const dispatch = useDispatch();

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API_ASSETZ_BASE_URL,
  timeout: 60000,
  headers: {
    Authorization: `Bearer ${token || user?.accessToken}`,
    // "Content-Type": "application/json",
    // Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    InternalApiKey: "123",
    "X-User-UserId": getReduxCompany()?.userId || 0,
    "X-User-UserName": getReduxCompany()?.userName || "",
    //"X-User-CompanyId": getReduxCompany()?.companyId || 0,
    "X-User-CompanyId": getStoredCompany()?.companyId || 0,
    "X-IP-Address": devideInfo?.iPAddress || "",
    "X-Device-Info": devideInfo?.deviceInfo || "",
    "X-Is-Browser": devideInfo?.isMobile,
  },
  //timeout: 5000,
});




axiosApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("session_accesstoken")
      ? localStorage.getItem("session_accesstoken")
      : null;
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);


axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log("intercepted error---", error);

    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      let token = await getRefreshAccessToken(user?.refreshToken);
      originalRequest.headers.Authorization = `Bearer ${token}`;
      return axiosApi(originalRequest);
    }
    return Promise.reject(error);
  }
);


  const getRefreshAccessToken = async (refreshToken) => {
    const request = {
      refreshToken: refreshToken || "",
      accessToken: localStorage.getItem("session_accesstoken") || "",

    };

    const res = await refreshAccessToken(request)
    if (res?.isSuccess) {
       localStorage.removeItem("session_accesstoken");
      localStorage.setItem("session_accesstoken", res?.data);
       
    }
  }

export default axiosApi;
